import Vue from "vue";
import * as knows from "../../../static/json/knows.json";
//模块功能：气象知识
export default Vue.extend({
    name: "k-meteo",
    data: function () {
        return {
            crtIndex: 0,
            detailShow: false,
        };
    },
    mounted: function () {
    },
    methods: {
        /**
         * 功能：显示新闻列表
         */
        backList: function () {
            this.detailShow = false;
        },
        /**
         * 功能：显示新闻详情
         * @param index
         */
        toDetail: function (index) {
            this.crtIndex = index;
            this.detailShow = true;
        }
    },
    computed: {
        knowList: function () {
            var temp = knows['data'];
            var url = "../../../static/img/knows/";
            for (var _i = 0, _a = temp['meteo']; _i < _a.length; _i++) {
                var item = _a[_i];
                item.img = item.img == "" ? "" : url + item.img;
                for (var _b = 0, _c = item.contents; _b < _c.length; _b++) {
                    var item1 = _c[_b];
                    item1.img = item1.img == "" ? "" : url + item1.img;
                    item1.img_cn = item1.img_cn == "" ? "" : url + item1.img_cn;
                }
                if (item.wind) {
                    for (var _d = 0, _e = item.wind; _d < _e.length; _d++) {
                        var item2 = _e[_d];
                        for (var _f = 0, item2_1 = item2; _f < item2_1.length; _f++) {
                            var item3 = item2_1[_f];
                            item3.img = item3.img == "" ? "" : url + item3.img;
                        }
                    }
                }
            }
            return temp;
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/knows/k-meteo.vue
// module id = null
// module chunks = 